import RecordAction from '../RecordAction';
import { promoteToWorkspaceController } from 'components/PromoteToWorkspaceModal/PromoteToWorkspaceModalController';

export class PromoteToWorkspaceAction extends RecordAction {
  recordTypes = ['Feature', 'Epic'];

  get title() {
    return 'Promote to workspace';
  }

  showForSelectedRecords() {
    if (
      !window.currentProject?.isTeam ||
      !this.selectedRecords.every(
        record => record.project?.id === record.team?.id
      )
    ) {
      return false;
    }
    return super.showForSelectedRecords();
  }

  async runForRecords(records, _) {
    promoteToWorkspaceController.actionSetRecords(records);
    promoteToWorkspaceController.actionShowModal();
  }
}
